import { Component, Fragment } from 'react';
import DateTime from 'common/components/DateTime/DateTime';

import {
    FormSection,
} from 'forms/components/common';

const MonitorVisitFields = ( event ) => {
    return [
        <FormSection headerText="Visit Type" data-cy="MonitorVisitFields">
            {event.monitorVisitType}
        </FormSection>,
        <FormSection headerText="Date of Monitoring Visit">
            <DateTime value={event.dateOfVisit} time={false} format={'DD MMM YYYY'}/>
        </FormSection>,
        <FormSection headerText="Monitor">
            {event.monitor.displayName}
        </FormSection>
    ];
};

const ICFChangeFields = ( event ) => {
    return [
        <FormSection headerText="IRB Approval Date" data-cy="ICFChangeFields">
            <DateTime value={event.irbApprovalDate} time={false} format={'DD MMM YYYY'}/>
        </FormSection>,
        <FormSection headerText="ICF Type">
            {event.icfType}
        </FormSection>,
        <FormSection headerText="ICF Language">
            {event.icfLanguage}
        </FormSection>,
        <FormSection headerText="Reconsent Required">
            {event.reconsentRequired}
        </FormSection>,
        <FormSection headerText="Sponsor Version">
            {event.sponsorVersion}
        </FormSection>,
        <FormSection headerText="Site Version">
            {event.siteVersion}
        </FormSection>,
        <FormSection headerText="Protocol Version">
            {event.protocolVersion}
        </FormSection>,
        <FormSection headerText="Summary of Changes">
            {event.summaryOfChanges}
        </FormSection>
    ];
};

const EventTypeFieldsMap = {
    'Monitor Visit': MonitorVisitFields,
    'ICF Version Change': ICFChangeFields,
};

class EventDetails extends Component {
    onSignEventSignatureRequest(token){
        this.props.onSignEventSignatureRequest(token);
    }

    getEventTypeFields(event) {
        const eventFields = EventTypeFieldsMap[event.eventType];

        return eventFields(event);
    }

    

    render() {
        const { signatureRequest } = this.props;
        const eventTypeFields = this.getEventTypeFields(signatureRequest.event);

        return (
            <Fragment data-cy="EventDetails">
                <FormSection headerText="Binder">
                    {signatureRequest.binderName}
                </FormSection>
                <FormSection headerText="From">
                    {signatureRequest.createdBy.displayName}
                </FormSection>
                <FormSection headerText="Sent Date">
                    <DateTime value={signatureRequest.sentDate} time={false} format={'DD MMM YYYY'}/>
                </FormSection>
                <FormSection headerText="Event Type">
                    {signatureRequest.event.eventType}
                </FormSection>

                {eventTypeFields}

                <FormSection headerText="Statement of Testament">
                    I approve the details of this Event
                </FormSection>
            </Fragment>
        );
    }
}

export default EventDetails;
